import styled from 'styled-components'

export const Title = styled.h5`
  font-size: 20px;
  font-weight: 700;
  margin-top: 10px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.neutralW90};
`

export const Content = styled.div`
  margin-right: 35px;
`

export const XButtonWrapper = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: inherit;
  display: flex;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 25px;
  top: 24px;

  svg {
    cursor: pointer;
    height: 24px;
    width: 24px;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const DescriptionCounter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.neutralW70};
  font-size: 12px;
  font-weight: 400;
`

export const PlaylistForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ $isMobile, $redesigned }) =>
    $redesigned ? ($isMobile ? '16px' : '24px') : 0};
  width: 100%;
`

export const ModalHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  width: 100%;
`

export const ModalTitle = styled.h5`
  color: ${({ theme }) => theme.colors.neutralW90};
  flex: 1;
  font-size: ${({ $isMobile }) => ($isMobile ? '16px' : '20px')};
  font-weight: 700;
  line-height: ${({ $isMobile }) => ($isMobile ? '1.5' : 'normal')};
  margin: 0;
  overflow: hidden;
  padding-right: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const CloseButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.neutralW80};
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: 0;
  width: 24px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.player50};
    outline-offset: 2px;
  }

  svg {
    height: 24px;
    width: 24px;
  }
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`

export const FieldLabelRow = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.neutralW90};
  display: flex;
  justify-content: space-between;
  min-height: 24px;
  width: 100%;
`

export const FieldLabel = styled.label`
  color: inherit;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
`

export const CharacterCounter = styled.span`
  color: inherit;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
`

export const FormError = styled.p`
  color: ${({ theme }) => theme.colors.error70};
  font-size: 12px;
  line-height: 1.5;
  margin: -8px 0 0;
`

export const SubmitButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;

  button {
    min-height: 36px;
    width: ${({ $isMobile }) => ($isMobile ? '100%' : 'auto')};
  }
`
